// ** Initial State
const initialState = {
  allUsersData: [],
  trashData: [],
  // data: [],
  // total: 1,
  // params: {},
  selectedUser: null
}

const users = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allUsersData: action.data, selectedUser: {} }
    case 'DELETE_ALL_USER_DATA':
      return initialState
    case 'GET_ALL_TRASH_DATA':
      return { ...state, trashData: action.data, selectedUser: {} }
    case 'GET_DATA':
      let arr
      if (action.params.status !== "") {
        arr = action.params.info.filter(item => item.isActive === action.params.status)
      } else {
        arr = action.params.info
      }
      return {
        ...state,
        data: arr,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_USER':
      return { ...state, selectedUser: action.selectedUser }
    case 'ADD_USER':
      return { ...state }
    case 'DELETE_USER':
      return { ...state }
    case 'CHANGE_STATUS':
      return { ...state }
    default:
      return { ...state }
  }
}
export default users
